import { FeedAdBackdropLayerControls } from './feed-ad-backdrop-layer-controls'
import { FeedAdContentLayerControls } from './feed-ad-content-layer-controls'
import { LayerManager } from './shared'

export function FeedAdLayerManager() {
	return (
		<>
			<LayerManager
				contentLayerControls={<FeedAdContentLayerControls />}
				backdropLayerControls={<FeedAdBackdropLayerControls />}
			/>
		</>
	)
}
